export default {
  en: {
    dailyActivityReport: 'Daily Activity Report',
    productMix: 'Product Mix',
    productMixAnalysis: 'Product Mix Analysis',
    shiftManagerSummary: 'Shift Manager Summary',
    shiftManagerSummaryAnalysis: 'Shift Manager Summary Analysis',
    footerDisclaimer: '* Metrics are averaged by the number of shifts worked',
    gridName: 'Grid Name',
    byDate: 'By Date',
    byMonth: 'By Month',
    sumAllDates: 'Sum all Dates',
    customDateRange: 'Custom Date Range',
    targets: 'Targets',
    total: 'Total',
  },
  es: {
    dailyActivityReport: 'Reporte de Actividad Diaria',
    productMix: 'Mezcla de Productos',
    productMixAnalysis: 'Análisis de Mezcla de Productos',
    shiftManagerSummary: 'Resumen del Jefe de Turno',
    shiftManagerSummaryAnalysis: 'Análisis del Resumen del Jefe de Turno',
    footerDisclaimer: '* Las métricas se promedian por el número de turnos trabajados',
    gridName: 'Nombre de la Cuadrícula',
    byDate: 'Por Fecha',
    byMonth: 'Por Mes',
    sumAllDates: 'Sumar todas las Fechas',
    customDateRange: 'Rango de Fechas Personalizado',
    targets: 'Objetivos',
    total: 'Total',
  },
};
